import { CardClickPopupType } from '@colonist/game-card-types';
import { CardEnum, CardTypeEnum, TurnState } from '@colonist/game-states';
export function getProgressCardDataScience() {
    return [
        {
            cardEnum: CardEnum.ProgressCardScienceBack,
            cardTypeEnum: CardTypeEnum.ProgressScience,
            isCardBack: true,
            clickPopupType: CardClickPopupType.None,
            allowableTurnStates: undefined
        },
        {
            cardEnum: CardEnum.ProgressCardScienceAlchemist,
            cardTypeEnum: CardTypeEnum.ProgressScience,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Dice
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardScienceCrane,
            cardTypeEnum: CardTypeEnum.ProgressScience,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardScienceEngineer,
            cardTypeEnum: CardTypeEnum.ProgressScience,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardScienceInventor,
            cardTypeEnum: CardTypeEnum.ProgressScience,
            isCardBack: false,
            clickPopupType: CardClickPopupType.NormalClick,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardScienceIrrigation,
            cardTypeEnum: CardTypeEnum.ProgressScience,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardScienceMedicine,
            cardTypeEnum: CardTypeEnum.ProgressScience,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardScienceMining,
            cardTypeEnum: CardTypeEnum.ProgressScience,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardSciencePrinter,
            cardTypeEnum: CardTypeEnum.ProgressScience,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardScienceRoadBuilding,
            cardTypeEnum: CardTypeEnum.ProgressScience,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn
            ]
        },
        {
            cardEnum: CardEnum.ProgressCardScienceSmith,
            cardTypeEnum: CardTypeEnum.ProgressScience,
            isCardBack: false,
            clickPopupType: CardClickPopupType.ConfirmationPopup,
            allowableTurnStates: [
                TurnState.Turn
            ]
        }
    ];
}
